import React, { useEffect } from "react";
import { useState } from "react";
import Footer from "../../../MyComponents/Footer";
// import GuestNav from "../../../MyComponents/Navbars/GuestNav";
import Hero2 from "../../../MyComponents/Hero2";
import FAQS from "../../../MyComponents/FooterPages/newfaq"
import heroContent from "../HeroContent-GDesign";
import leftimgs from "../../../assets/adobeleftimg.png";
import rightimgs from "../../../assets/adoberightimg.png";
import CourseTimeline from "../../../MyComponents/CourseTimeline";
import Benefits from "../../../MyComponents/Benefits";
import FunActivities from "../../../MyComponents/FunActivities";
import BenefitsDataImg1 from "../../../assets/illustrator-benefit-img1.png";
import BenefitsDataImg2 from "../../../assets/illustrator-benefit-img2.png";
import BenefitsDataImg3 from "../../../assets/illustrator-benefit-img5.png";
import BenefitsDataImg4 from "../../../assets/illustrator-benefit-img4.png";
import BenefitsDataImg5 from "../../../assets/illustrator-benefit-img5.png";
import BenefitsDataImg6 from "../../../assets/illustrator-benefit-img6.png";
import BenefitsDataImg7 from "../../../assets/illustrator-benefit-img2.png";
import BenefitsDataImg8 from "../../../assets/illustrator-benefit-img8.png";
import BenefitsDataImg9 from "../../../assets/illustrator-benefit-img9.png";
import FunactivitiesImg1 from "../../../assets/illustratorFun-img1.png";
import FunactivitiesImg2 from "../../../assets/illustratorFun-img2.png";
import FunactivitiesImg3 from "../../../assets/illustratorFun-img3.png";
import FunactivitiesImg4 from "../../../assets/illustratorFun-img4.png";
import FunactivitiesImg5 from "../../../assets/illustratorFun-img5.png";
import LearningStyle from "../../../MyComponents/LearningStyle"
import VideoSection from "../../../MyComponents/VideoSection";
import Testimonials from "../../../MyComponents/Testimonials";
import HeadSection from "../../HeadSection.js";
import pencilIcon from "../../../assets/pencil.png";
 const beginnerModules = [
    {
      title: "Module 1",
      activities: "11",
      classes: "07",
      description:"Introduction to Graphic Designing- Learn graphic design fundamentals, image sourcing, file formats, and explore online marketplaces to earn money using design skills.",
    },
    {
      title: "Module 2",
      activities: "11",
      classes: "07",
      description:" Adobe Illustrator Basics- Understand Adobe Illustrator basics, working with shapes, tools, color palettes, and concepts like Mask and Stroke.",
    },
    {
      title: "Module 3",
      activities: "11",
      classes: "08",
      description:" Adobe Illustrator Advanced-  Master advanced Illustrator features like Swatches, Patterns, image tracing, and design creation for logos, business cards, letterheads, and CVs",
    },
];    

  const benefitsData = [
      {
        title: "Graphic Design Fundamentals",
        description: "Build a strong base in design concepts.",
        icon: "Polymath-images/illustrator-benefit-img1.png",
      },
      {
        title: "principles of Design",
        description: "Learn balance, contrast, alignment, and hierarchy.",
        icon: "Polymath-images/illustrator-benefit-img2.png",
      },
      {
        title: "Adobe Illustrator Basics",
        description: "Get comfortable with workspace and essential tools.",
        icon: "Polymath-images/illustrator-benefit-img5.png",
      },
      {
        title: "Advanced Illustrator ",
        description: "Use layers, artboards, and effects like a pro.",
        icon: "Polymath-images/illustrator-benefit-img4.png",
      },
      {
        title: "Pen, Shape & Type Tools",
        description: "Create precise paths, custom shapes, and stylish text",
        icon: "Polymath-images/illustrator-benefit-img5.png",
      },
      {
        title: "Color Swatches & Patterns",
        description: "Apply color theory using swatches, gradients, and patterns",
        icon: "Polymath-images/illustrator-benefit-img6.png",
      },
      {
        title: "CV, Logo & Flyer Design",
        description: "Design personal branding and professional assets.",
        icon: "Polymath-images/illustrator-benefit-img2.png",
      },
      {
        title: "Image Trace Tool",
        description: "Convert raster images to clean vector artwork.",
        icon: "Polymath-images/illustrator-benefit-img8.png",
      },
      {
        title: "Live Paint Tool",
        description: "Easily fill shapes and illustrations with color.",
        icon: "Polymath-images/illustrator-benefit-img9.png",
      },
    ];
    const activitiesData = [
        {
          title: "UI/UX Fundamentals",
          image: "Polymath-images/illustratorFun-img1.png",
        },
        {
          title: "Animations",
          image: "Polymath-images/illustratorFun-img2.png",
        },
        {
          title: "Shapes",
          image: "Polymath-images/illustratorFun-img3.png",
        },
        {
          title: "Logo Designing",
          image: "Polymath-images/illustratorFun-img4.png",
        },
        {
          title: "Business Cards",
          image: "Polymath-images/illustratorFun-img5.png",
        },
      ];
     const videoData = {
    title: "Watch Our Introduction Video",
    description:
      "Discover how kids can turn their creativity into stunning designs! In this video, we’ll introduce fun tools, basic design tips, and exciting projects like logos, flyers, and digital art. Whether you're just starting out or love being creative, this is the perfect place to begin your design journey.",

      
    videoSrc: "https://www.youtube.com/embed/p4pilMiPITE",
  };
const Illustrator = () => {
  const Illustratorpage = heroContent.illustratorsection;
  return (
    <>
     {/* <GuestNav/> */}
      <HeadSection
      leftImg={"Polymath-images/adobeleftimg.png"}
      rightImg={"Polymath-images/adoberightimg.png"}
      titlePart1="Adobe Illustrator"
      titlePart2="Course"
      description="Polymath-Kids offers an Adobe Illustrator course where kids learn graphic design fundamentals through live online classes. Students will master basic and advanced Illustrator tools, creating custom drawings, logos, business cards, and more, while developing creativity, artistry, and problem-solving skills."
      button1Text= {false}
      button2Text="Book Free Demo Class"
      button1Icon={"Polymath-images/pencil.png"}
      button2Icon={"Polymath-images/pencil.png"}
      onButton1Click={() => alert("Early bird discount clicked!")}
      onButton2Click={() => alert("Book demo clicked!")}
    />
       <CourseTimeline
        title="Course Structure and Syllabus"
        modules={beginnerModules}
      />
       <Benefits
        title="How Students Can Benefit From Abacus"
        benefitsData={benefitsData}
      />
       <FunActivities
              mainTitle="Learn Corel Draw"
              subTitle="With 40+ Fun Activities"
              activities={activitiesData}
            />
        <LearningStyle/>
         <VideoSection
        title={videoData.title}
        description={videoData.description}
        videoSrc={videoData.videoSrc}
      />
      <Testimonials/>
      <FAQS/>
       <Footer/>
    </>
  )
}
export default Illustrator